/* 🤖 this file was generated by svg-to-ts */
export const matIconPause: {
  name: 'pause';
  data: string;
} = {
  name: 'pause',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>`
};
